const localeEs = {
  es: {
    BREADCRUMB_1: 'Home',
    BREADCRUMB_2: 'Descargables',

    RESOURCE_NEW: 'Nuevo',
    RESOURCE_DOWNLOADS: 'descargas',
    RESOURCE_DOWNLOAD_BUTTON: 'Descargar',

    UNLOCKED_TITLE: '¡Gracias por registrarte!',
    UNLOCKED_SUBTITLE: 'Ahora comienza a disfrutar de este recurso.',

    FORM_TITLE_1: 'Regístrate',
    FORM_TITLE_2: 'para',
    FORM_TITLE_3: 'descargar este recurso',
    FORM_NAME: 'Nombre',
    FORM_LASTNAME: 'Apellido',
    FORM_EMAIL: 'Correo electrónico',
    FORM_COMPANY: 'Nombre de tu empresa',
    FORM_BUTTON: 'Registrarme',
    FORM_ERROR_REQUIRED: 'Campo requerido',
    FORM_ERROR_MAX_LENGTH: 'Máximo 50 caracteres',
    FORM_ERROR_EMAIL: 'Por favor, ingresa un email válido.',
    FORM_ERROR_LABEL: 'Error',
    FORM_RECOMMENDATIONS_TITLE: 'También te podrían interesar estos recursos',
    FORM_FIELD_ORG_SIZE: 'Número de colaboradores',
    FORM_COMPANY_SIZE_250: '1 a 250 colaboradores',
    FORM_COMPANY_SIZE_1000: 'Más de 1000 colaboradores',
    FORM_COMPANY_SIZE_MORE_250: '251 a 999 colaboradores',
    FORM_PHONE_LABEL: 'Número de Teléfono',
    FORM_SELECT: 'Selecciona',
    SHARE_RESOURCE: 'Comparte este articúlo',
  },
};

export default localeEs;
